var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-menu",attrs:{"tabindex":""},on:{"focusout":_vm.close}},[_c('span',{staticClass:"t-menu__activator",on:{"click":_vm.toggle}},[_vm._t("activator")],2),_vm._v(" "),_c('div',{staticClass:"t-menu__content",class:[
      ("t-menu__content--align-" + _vm.align),
      { 't-menu__content--open': _vm.open }
    ],on:{"click":_vm.dismiss}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }